<template>
  <div
    class="b-overlay-wrap position-relative"
    :aria-busy="show ? 'true' : 'false'"
  >
    <!-- Wrapped content -->
    <slot></slot>

    <!-- Overlay -->
    <div
      v-if="show"
      class="b-overlay position-absolute"
      style="inset: 0; z-index: 10;"
    >
      <!-- Backdrop -->
      <div
        class="position-absolute bg-light"
        :style="{
          inset: '0',
          opacity: opacity,
          'backdrop-filter': blur ? `blur(${blur}px)` : 'none'
        }"
      ></div>

      <!-- Spinner -->
      <div
        class="position-absolute"
        style="top: 50%; left: 50%; transform: translate(-50%, -50%);"
      >
        <span
          class="spinner-border"
          :class="spinnerClass"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bs5Overlay",
  props: {
    show: { type: Boolean, default: false },
    opacity: { type: Number, default: 0.4 },
    blur: { type: Number, default: 2 },
    spinnerClass: { type: String, default: "" }
  }
};
</script>

<style scoped>
.b-overlay-wrap {
  display: block;
}

.b-overlay {
  pointer-events: none; /* Same as BootstrapVue overlay */
}
</style>
